export type PrimaryServiceHref = `/blog/${string}` | "/blog" | `/tuition#${"ip" | "jc" | "practical"}`;

export type PrimaryServiceNavLink = {
  label: string;
  href: PrimaryServiceHref;
  gaLabel: string;
  children?: readonly PrimaryServiceSubNavLink[];
  childColumns?: readonly PrimaryServiceSubNavColumn[];
};

export type PrimaryServiceSubNavLink = {
  label: string;
  shortLabel?: string;
  href: PrimaryServiceHref;
  gaLabel: string;
};

export type PrimaryServiceSubNavColumn = {
  heading?: string;
  links: readonly PrimaryServiceSubNavLink[];
};

export const PRIMARY_SERVICE_NAV_LINKS: readonly PrimaryServiceNavLink[] = [
  {
    label: "IP Tuition",
    href: "/tuition#ip",
    gaLabel: "ip_tuition",
    childColumns: [
      {
        links: [
          {
            label: "Lower Sec Maths",
            href: "/blog/ip-lower-secondary-maths-tuition",
            gaLabel: "ip_lower_secondary_maths",
          },
          {
            label: "Lower Sec Science",
            href: "/blog/ip-lower-secondary-science-tuition",
            gaLabel: "ip_lower_secondary_science",
          },
        ],
      },
      {
        links: [
          {
            label: "Upper Sec Maths",
            href: "/blog/ip-upper-secondary-maths-tuition",
            gaLabel: "ip_upper_secondary_maths",
          },
          {
            label: "Upper Sec Physics",
            href: "/blog/ip-upper-secondary-physics-tuition",
            gaLabel: "ip_upper_secondary_physics",
          },
        ],
      },
      {
        links: [
          {
            label: "Upper Sec Chemistry",
            href: "/blog/ip-upper-secondary-chemistry-tuition",
            gaLabel: "ip_upper_secondary_chemistry",
          },
          {
            label: "Upper Sec Biology",
            href: "/blog/ip-upper-secondary-biology-tuition",
            gaLabel: "ip_upper_secondary_biology",
          },
        ],
      },
    ],
  },
  {
    label: "JC Tuition",
    href: "/tuition#jc",
    gaLabel: "jc_tuition",
    children: [
      {
        label: "H2 Maths",
        href: "/blog/a-level-maths-tuition",
        gaLabel: "h2_maths",
      },
      {
        label: "H2 Physics",
        href: "/blog/a-level-physics-tuition",
        gaLabel: "h2_physics",
      },
      {
        label: "H2 Chemistry",
        href: "/blog/a-level-chemistry-tuition",
        gaLabel: "h2_chemistry",
      },
      {
        label: "H2 Biology",
        href: "/blog/a-level-biology-tuition",
        gaLabel: "h2_biology",
      },
    ],
  },
  {
    label: "Practical Training",
    href: "/tuition#practical",
    gaLabel: "practical_training",
    childColumns: [
      {
        heading: "IP",
        links: [
          {
            label: "IP Science Practicals",
            shortLabel: "Overview",
            href: "/blog/ip-science-practicals",
            gaLabel: "ip_science_practicals",
          },
          {
            label: "IP Lower Secondary Science Practicals",
            shortLabel: "Lower Sec Science",
            href: "/blog/ip-lower-secondary-science-practicals",
            gaLabel: "ip_lower_secondary_science_practicals",
          },
          {
            label: "IP Physics Practicals",
            shortLabel: "Physics",
            href: "/blog/ip-physics-practicals",
            gaLabel: "ip_physics_practicals",
          },
          {
            label: "IP Chemistry Practicals",
            shortLabel: "Chemistry",
            href: "/blog/ip-chemistry-practicals",
            gaLabel: "ip_chemistry_practicals",
          },
          {
            label: "IP Biology Practicals",
            shortLabel: "Biology",
            href: "/blog/ip-biology-practicals",
            gaLabel: "ip_biology_practicals",
          },
        ],
      },
      {
        heading: "O-Level Pure",
        links: [
          {
            label: "Pure Physics Practical",
            shortLabel: "Physics",
            href: "/blog/o-level-physics-experiments",
            gaLabel: "pure_physics_practical",
          },
          {
            label: "Pure Chemistry Practical",
            shortLabel: "Chemistry",
            href: "/blog/o-level-chemistry-experiments",
            gaLabel: "pure_chemistry_practical",
          },
          {
            label: "Pure Biology Practical",
            shortLabel: "Biology",
            href: "/blog/o-level-biology-experiments",
            gaLabel: "pure_biology_practical",
          },
        ],
      },
      {
        heading: "O-Level Combined",
        links: [
          {
            label: "Combined Physics Practical",
            shortLabel: "Physics",
            href: "/blog/o-level-science-physics-practical",
            gaLabel: "combined_physics_practical",
          },
          {
            label: "Combined Chemistry Practical",
            shortLabel: "Chemistry",
            href: "/blog/o-level-science-chemistry-practical",
            gaLabel: "combined_chemistry_practical",
          },
          {
            label: "Combined Biology Practical",
            shortLabel: "Biology",
            href: "/blog/o-level-science-biology-practical",
            gaLabel: "combined_biology_practical",
          },
        ],
      },
      {
        heading: "A-Level H2",
        links: [
          {
            label: "H2 Physics Practical",
            shortLabel: "Physics",
            href: "/blog/h2-physics-experiments",
            gaLabel: "h2_physics_practical",
          },
          {
            label: "H2 Chemistry Practical",
            shortLabel: "Chemistry",
            href: "/blog/h2-chemistry-experiments",
            gaLabel: "h2_chemistry_practical",
          },
          {
            label: "H2 Biology Practical",
            shortLabel: "Biology",
            href: "/blog/h2-biology-experiments",
            gaLabel: "h2_biology_practical",
          },
        ],
      },
    ],
  },
  {
    label: "Study Resources",
    href: "/blog",
    gaLabel: "blog",
  },
] as const;
